import { Controller } from "@hotwired/stimulus"

// Exclusividade entre checkboxes de produto. Marcar um produto "exclusivo"
// (ex.: CONVÊNIO/COMBUSTÍVEL) desmarca todos os outros; mexer num produto
// não-exclusivo desmarca os exclusivos. Os ids exclusivos vêm do value
// `exclusive-ids`. A action escuta `change` no form (o evento borbulha) e
// filtra apenas inputs com a classe `produto`.
export default class extends Controller {
  static values = { exclusiveIds: Array }

  toggle(event) {
    const changed = event.target
    if (!changed.classList.contains("produto")) return

    const exclusiveIds = this.exclusiveIdsValue
    const produtos = this.element.querySelectorAll("input.produto")

    if (exclusiveIds.includes(changed.id)) {
      produtos.forEach((cb) => { if (cb !== changed) cb.checked = false })
    } else {
      produtos.forEach((cb) => { if (exclusiveIds.includes(cb.id)) cb.checked = false })
    }
  }
}
